import type { RuleObject } from 'antd/es/form';
import type { StoreValue } from 'rc-field-form/lib/interface';
import type { IntlShape } from 'react-intl';

import { normalizePhoneInput, validatePhoneByInferredPrefix } from './phonePrefixValidation';

/**
 * Ant Design Form.Item `rules[].validator` (rc-field-form / async):
 * resolve = valid, reject(Error) = invalid.
 */
export type PhoneFormAsyncValidator = (
  rule: RuleObject,
  value: StoreValue,
) => Promise<void> | void;

const isPhoneValueEmpty = (value: StoreValue): boolean =>
  value === undefined || value === null || String(value).trim() === '';

const rejectInvalidPhone = (intl: IntlShape): never => {
  throw new Error(intl.formatMessage({ id: 'country.phone.invalid' }));
};

/** Validates phone from inferred international prefix + national length rules in phonePrefixes.json. */
export const createPhoneFormValidator = (intl: IntlShape): PhoneFormAsyncValidator => {
  return async (_rule, value) => {
    void _rule;
    if (isPhoneValueEmpty(value)) return;

    const normalized = normalizePhoneInput(value);
    const result = validatePhoneByInferredPrefix(normalized);
    if (result.ok) return;
    rejectInvalidPhone(intl);
  };
};
